import type {ReactElement} from 'react';
import React from 'react';
import styles from './submit-button.module.scss';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import {Button, Size} from '@Components/button';
import type {AsyncVoidFunction} from '@Utils/general.util';
import type {AuthenticateModalContent} from "@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types";
import {openAuthenticateModal} from "@Modals/authenticate-modal";

interface SubmitButtonProps {
  isLoading: boolean;
  isActive: boolean;
  onSubmission: AsyncVoidFunction;
  showUpsellDialog: boolean;
  upsellDialog?: string;
  authenticateModalContent?: AuthenticateModalContent;
}

export function SubmitButton({isLoading, isActive, onSubmission, ...props}: SubmitButtonProps): ReactElement {
  const getLoader = (): ReactElement => {
    return (
      <div className={`spacing-p-r-2 spacing-p-l-2 ${styles.loader} `}>
        <CircularProgressLoader color={LOADER_COLOR.AI_DARK} size={LOADER_SIZE.XSMALL} />
      </div>
    );
  };

  const handleClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    if (props.authenticateModalContent?.showModal) {
      openAuthenticateModal(props.authenticateModalContent.modalProps);
      return;
    }

    if (props.showUpsellDialog) {
      void window.PMW.showPremiumOnlyFeatureDialog(props.upsellDialog ?? '');
      return;
    }

    void onSubmission();
  };

  const getButton = (): ReactElement => {
    return (
      <div className={isActive ? styles.submitButtonContainer : ''}>
        <Button
          icon={'icon-chat-send'}
          size={Size.XSMALL}
          customClasses={`spacing-p-2 ${styles.submitButton} ${isActive ? styles.active : ''}`}
          disabled={!isActive}
          onClick={handleClick}
        />
      </div>
    );
  };

  const getSubmitButton = (): ReactElement => {
    if (isLoading) {
      return getLoader();
    }

    return getButton();
  };

  return getSubmitButton();
}
